<template>
  <el-pagination
    v-show="hideWhenEmpty ? total > 0 : true"
    :class="rootClass"
    :style="rootStyle"
    :background="backgroundResolved"
    :layout="resolvedLayout"
    :total="total"
    :page-size="pageSize"
    :current-page="currentPage"
    :page-sizes="resolvedPageSizes"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
  />
</template>

<script>
import { DEFAULT_PAGE_SIZES, PORTAL_CARD_PAGE_SIZES, mergePageSizes } from "@/utils/pagination";

/**
 * 全站统一分页：支持自选每页条数。
 * 用法：:page-size.sync / :current-page.sync + @change 触发列表刷新
 */
export default {
  name: "AppPagination",
  props: {
    total: { type: Number, default: 0 },
    pageSize: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    /** 自定义每页条数选项；不传则按 variant 使用默认值 */
    pageSizes: { type: Array, default: null },
    /** admin 管理端 | portal 用户门户 */
    variant: { type: String, default: "admin" },
    background: { type: Boolean, default: null },
    pagerClass: { type: [String, Array, Object], default: "" },
    /** 切换每页条数时重置到的页码（Cloud 应用列表等为 0） */
    pageBase: { type: Number, default: 1 },
    layout: { type: String, default: "" },
    hideWhenEmpty: { type: Boolean, default: true },
    marginTop: { type: String, default: "" },
  },
  computed: {
    backgroundResolved() {
      if (this.background !== null) return this.background;
      return this.variant === "portal";
    },
    resolvedLayout() {
      if (this.layout) return this.layout;
      if (this.variant === "portal") return "prev, pager, next, total, sizes";
      return "total, prev, pager, next, sizes";
    },
    resolvedPageSizes() {
      const base = this.pageSizes || (this.variant === "portal" ? PORTAL_CARD_PAGE_SIZES : DEFAULT_PAGE_SIZES);
      return mergePageSizes(this.pageSize, base);
    },
    rootClass() {
      const extra = this.variant === "portal" ? "portal-pager" : "";
      if (!this.pagerClass && !extra) return "";
      if (!this.pagerClass) return extra;
      if (!extra) return this.pagerClass;
      return [extra, this.pagerClass];
    },
    rootStyle() {
      if (this.marginTop) return { marginTop: this.marginTop };
      if (this.pagerClass || this.variant === "portal") return null;
      return { marginTop: "12px" };
    },
  },
  methods: {
    handleSizeChange(size) {
      this.$emit("update:pageSize", size);
      this.$emit("update:currentPage", this.pageBase);
      this.$emit("size-change", size);
      this.$emit("change");
    },
    handleCurrentChange(page) {
      this.$emit("update:currentPage", page);
      this.$emit("current-change", page);
      this.$emit("change");
    },
  },
};
</script>
